"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BrandLister_module_1 = tslib_1.__importDefault(require("./modules/BrandLister.module"));
const loadBrandListerModule = (initialData) => ({
    hasRouter: true,
    modules: [(0, BrandLister_module_1.default)(initialData)],
});
exports.default = loadBrandListerModule;
